import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Fade from "react-reveal/Fade";
function Model() {
  const navigate = useNavigate();
  return (
    <Fade>
      <Container>
        <Modelheader>
          <Left onClick={() => navigate("/")}>
            <img src="/images/back.png"></img>
          </Left>
          <Title>
            <h2>Talent</h2>
          </Title>
        </Modelheader>

        <Grid>
          <ModelCard>
            <ImageBox>
              <h3>Erica Grisby</h3>
              <a
                href="https://instagram.com/ericagrisby?igshid=YmMyMTA2M2Y="
                target={"_blank"}
              >
                <img src="./images/Instagram.png" />
              </a>
              <img src="https://ik.imagekit.io/euo36lugk/Nutrire/IMG_8443_kSo2wXtpM.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1672607036135" />
            </ImageBox>
          </ModelCard>
          <ModelCard>
            <ImageBox>
              <h3>Olivia Orange County</h3>
              <a
                href="https://instagram.com/missoliviak?igshid=YmMyMTA2M2Y="
                target={"_blank"}
              >
                <img src="./images/Instagram.png" />
              </a>
              <img src="https://ik.imagekit.io/euo36lugk/Nutrire/IMG_5219_fSytNs9Q2S.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1672606533008" />
            </ImageBox>
          </ModelCard>
          <ModelCard>
            <ImageBox>
              <h3>Mia La</h3>
              <a
                href="https://instagram.com/miamarie23?igshid=YmMyMTA2M2Y="
                target={"_blank"}
              >
                <img src="./images/Instagram.png" />
              </a>
              <img src="https://ik.imagekit.io/euo36lugk/Nutrire/miala_3_6zqiZBF.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1672607038798" />
            </ImageBox>
          </ModelCard>

          <ModelCard>
            <ImageBox>
              <h3>Taylor Utah</h3>
              <a
                href="https://instagram.com/tayybroooke?igshid=YmMyMTA2M2Y="
                target={"_blank"}
              >
                <img src="./images/Instagram.png" />
              </a>
              <img src="https://ik.imagekit.io/euo36lugk/Nutrire/taylorutah_WH_FMsT1j.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1672606534282" />
            </ImageBox>
          </ModelCard>
          <ModelCard>
            <ImageBox>
              <h3>River Utah</h3>
              <a href="https://www.instagram.com/riverutley/" target={"_blank"}>
                <img src="./images/Instagram.png" />
              </a>
              <img src="https://ik.imagekit.io/euo36lugk/Nutrire/riverutah_dpnoBoTL9.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1672607040690" />
            </ImageBox>
          </ModelCard>

          <ModelCard>
            <ImageBox>
              <h3>Rachel Britt</h3>
              <a
                href="https://instagram.com/rachelbritt24?igshid=YmMyMTA2M2Y="
                target={"_blank"}
              >
                <img src="./images/Instagram.png" />
              </a>
              <img src="https://ik.imagekit.io/euo36lugk/Nutrire/rachelbritt_AW87NrhUhW.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1672607038889" />
            </ImageBox>
          </ModelCard>
          <ModelCard>
            <ImageBox>
              <h3>Laura Le</h3>
              <a
                href="https://instagram.com/laurale4?igshid=YmMyMTA2M2Y="
                target={"_blank"}
              >
                <img src="./images/Instagram.png" />
              </a>
              <img src="https://ik.imagekit.io/euo36lugk/Nutrire/IMG_0325_Ok4iN5LtK.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1677172545271" />
            </ImageBox>
          </ModelCard>
          <ModelCard>
            <ImageBox>
              <h3>
                Lindsay <br />
                (makeup artist)
              </h3>
              <a
                href="https://instagram.com/beauty_by_lindsaylowe_?igshid=YmMyMTA2M2Y="
                target={"_blank"}
              >
                <img src="./images/Instagram.png" />
              </a>
              <img src="https://ik.imagekit.io/euo36lugk/Nutrire/IMG_3102_GGBnJyx2b_.jpeg?ik-sdk-version=javascript-1.4.3&updatedAt=1677173359844" />
            </ImageBox>
          </ModelCard>
          <ModelCard>
            <ImageBox>
              <h3>Gabriella</h3>
              <a
                href="https://instagram.com/gabriella_bmartinez?igshid=YmMyMTA2M2Y="
                target={"_blank"}
              >
                <img src="./images/Instagram.png" />
              </a>
              <img src="https://ik.imagekit.io/euo36lugk/Nutrire/IMG_20230223_231138_226_8OZs7TUA2.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677174211433" />
            </ImageBox>
          </ModelCard>
          <ModelCard>
            <ImageBox>
              <h3>Nadine</h3>
              <a
                href="https://instagram.com/nadinemartiinez?igshid=YmMyMTA2M2Y="
                target={"_blank"}
              >
                <img src="./images/Instagram.png" />
              </a>
              <img src="https://ik.imagekit.io/euo36lugk/Nutrire/image3_N8GdHbmzj.jpeg?ik-sdk-version=javascript-1.4.3&updatedAt=1677211919432" />
            </ImageBox>
          </ModelCard>
          <ModelCard>
            <ImageBox>
              <h3>
                Jessica Lopez <br />
                Model and actress
              </h3>
              <a
                href="https://instagram.com/lilj.lo?igshid=YmMyMTA2M2Y="
                target={"_blank"}
              >
                <img src="./images/Instagram.png" />
              </a>
              <img src="https://ik.imagekit.io/euo36lugk/Nutrire/5476A419-B175-449B-AE9B-417C6A664CFB_Mc_OePBF-.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1677304575005" />
            </ImageBox>
          </ModelCard>
          <ModelCard>
            <ImageBox>
              <h3>
                Melinda Johnson <br />
                SLC Utah photographer <br /> creative director
              </h3>
              <a
                href="https://instagram.com/melindajae?igshid=YmMyMTA2M2Y="
                target={"_blank"}
              >
                <img src="./images/Instagram.png" />
              </a>
              <img src="https://ik.imagekit.io/euo36lugk/Nutrire/IMG_61939D6B-B918-4421-82B4-8466471CB9F7_uX246Oqhk4.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677304567256" />
            </ImageBox>
          </ModelCard>
          <ModelCard>
            <ImageBox>
              <h3>
                Sierra <br />
                Model San Diego California
              </h3>
              <a
                href="https://instagram.com/sierraze?igshid=YmMyMTA2M2Y="
                target={"_blank"}
              >
                <img src="./images/Instagram.png" />
              </a>
              <img src="https://ik.imagekit.io/euo36lugk/Nutrire/IMG_0240_25SX2Pp16.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677304558516" />
            </ImageBox>
          </ModelCard>
          <ModelCard>
            <ImageBox>
              <h3>
                Sekona <br />
                makeup artist
              </h3>
              <a
                href="https://instagram.com/sekonaglow?igshid=YmMyMTA2M2Y="
                target={"_blank"}
              >
                <img src="./images/Instagram.png" />
              </a>
              <img src="https://ik.imagekit.io/euo36lugk/Nutrire/IMG_0333_Z6v-p0jqQ.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677305472607" />
            </ImageBox>
          </ModelCard>
          <ModelCard>
            <ImageBox>
              <h3>
                Heather <br />
                Photographer SLC Utah
              </h3>
              <a
                href="https://instagram.com/heatherwilkinsmendoza?igshid=YmMyMTA2M2Y="
                target={"_blank"}
              >
                <img src="./images/Instagram.png" />
              </a>
              <img src="https://ik.imagekit.io/euo36lugk/Nutrire/FB_IMG_1677295589050_hdrzM28Es.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1677347543342" />
            </ImageBox>
          </ModelCard>
          <ModelCard>
            <ImageBox>
              <h3>
                Aly <br />
                Influencer San Diego
              </h3>
              <a
                href="https://instagram.com/truethatalykat?igshid=YmMyMTA2M2Y="
                target={"_blank"}
              >
                <img src="./images/Instagram.png" />
              </a>
              <img src="https://ik.imagekit.io/euo36lugk/Nutrire/image0_6CdsGwpwLH.jpeg?updatedAt=1678609479278" />
            </ImageBox>
          </ModelCard>
          <ModelCard>
            <ImageBox>
              <h3>
                Melinda <br />
                Model
              </h3>
              <a href="https://www.instagram.com/melindajae/" target={"_blank"}>
                <img src="./images/Instagram.png" />
              </a>
              <img src="./images/image0.jpeg" />
            </ImageBox>
          </ModelCard>
          <ModelCard>
            <ImageBox>
              <h3>
                Lurelly <br />
                Model
              </h3>
              <a href="/" target={"_blank"}>
                <img src="./images/Instagram.png" />
              </a>
              <img src="https://ik.imagekit.io/euo36lugk/Nutrire/image1_wKC9mz9Bu.jpeg?updatedAt=1687535385935" />
            </ImageBox>
          </ModelCard>
          <ModelCard>
            <ImageBox>
              <h3>
                Cathryn <br />
                Model
              </h3>
              <a href="/" target={"_blank"}>
                <img src="./images/Instagram.png" />
              </a>
              <img src="https://ik.imagekit.io/euo36lugk/Nutrire/image0__1__7EKpvlwzLe.jpeg?updatedAt=1687535397587" />
            </ImageBox>
          </ModelCard>
        </Grid>
      </Container>
    </Fade>
  );
}
const Container = styled.div`
  position: relative;
  width: 100%;
  background-color: #161616;
`;
const Modelheader = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  padding-bottom: 30px;
  background: rgb(22, 22, 22);
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  padding: 5px 10px;
  background: linear-gradient(rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
`;

const Left = styled.div`
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translate(0, -50%);
  cursor: pointer;
  img {
    width: 30px;
  }
`;
const Title = styled.div`
  text-align: center;
  h2 {
    text-align: center;
    color: #c9a54e;
  }
`;
const Grid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding: 100px 0 50px;
  place-items: center;
  row-gap: 3rem;

  @media screen and (max-width: 1248px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media screen and (max-width: 968px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 624px) {
    grid-template-columns: 1fr;
  }
`;

const ModelCard = styled.div`
  height: 380px;
  width: 300px;
  overflow: hidden;
  position: relative;
`;

// const Overlay = styled.div`
//   background: rgba(0, 0, 0, 0.7);
//   position: absolute;
//   height: 100%;
//   width: 100%;
//   left: 0;
//   top: 0;
//   bottom: 0;
//   right: 0;
//   opacity: 0;
//   -webkit-transition: all 0.4s ease-in-out 0s;
//   -moz-transition: all 0.4s ease-in-out 0s;
//   transition: all 0.4s ease-in-out 0s;

//   :hover {
//     opacity: 1;
//   }
// `;

// const ImageDescription = styled.div`
//   display: flex;
//   flex-direction: column;
//   height: 100%;
//   color: #c9a54e;

//   p {
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     height: 100%;
//     font-size: 23px;
//   }

//   a {
//     display: flex;
//     justify-content: center;
//     align-items: center;
//   }
// `;

const ImageBox = styled.div`
  position: relative;
  h3 {
    color: #fff;
    position: absolute;
    left: 50%;
    top: 100%;
    transform: translateX(-50%);
    opacity: 0;
    text-align: center;
  }

  & > img {
    width: 102%;
    object-fit: cover;
    aspect-ratio: 4/5;
    transition: 500ms all ease-in-out;
  }

  &:hover > img {
    filter: brightness(40%);
    transition: 500ms all ease-in-out;
  }

  & > a img {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
  }

  &:hover > h3 {
    opacity: 1;
    color: #fff;
    z-index: 100;
    transition: 800ms all ease-in-out;
    top: 50%;
  }

  &:hover > a img {
    opacity: 1;
    color: #fff;
    z-index: 100;
    transition: 800ms all ease-in-out;
    top: 80%;
  }
`;

export default Model;
